(function() {
  'use strict';

  angular.module('component.reports', []);
})();
